const THREE = window.THREE;

class ResultState {
    constructor( app, options) {
        this.app = app;
        this.options = options;

        this.tempVec3 = new THREE.Vector3();
        this.tempQut = new THREE.Quaternion();
    }
    enter(){
        this.anchors = {};
        this.zhens = {}; //所有银针的模型
        this.zhensArr = [];
        this.box = {};
        this.boxArr = [];

   
        let highlightMat = new THREE.MeshLambertMaterial( {
                emissive: 0xffff00,
                transparent: true,
                opacity: 0.5
            });
        this.highlightMat = highlightMat;

        let renti = this.app.loader.models['renti.glb'];

        let modelNames = [{cfg:"DaChangYu",name:'dachangyu'},
                          {cfg:"SanYinJiao",name:"sanyinjiao"},
                          {cfg:"ShenQue",name:"shenque"},
                          {cfg:"TianShu",name:"tianshu"},
                          {cfg:"ShangJuXu", name:"shangjuxu"},
                          {cfg:"TaiChong",name:"taichong"},
                          {cfg:"QiMen",name:"qimen"}];
        
        renti.traverse(node=>{
            if( node.isMesh ) {
                if( node.name.indexOf('XueWei') == 0) {

                    let n = modelNames.length;
                    while(n--) {
                        let item = modelNames[n];
                        if( "XueWei_" + item.cfg == node.name ) {
                            this.anchors[item.name] = node;
                            break;
                        }
                    }
                }
            }
        });
        let boxglb = this.app.loader.models['box.glb'];
        boxglb.visible = true;
        boxglb.traverse(node=>{
            if( node.isMesh ) {
                let n = modelNames.length;
                while(n--) {
                    let item = modelNames[n];
                    if( node.name == item.name ) {
                        this.box[item.name] = node;
                        node.material = highlightMat;
                        this.boxArr.push( node );
                        break;
                    }
                }
            }
        });
        console.log("====>");
        console.log( this.box );

        modelNames = [{cfg:"zhen_DaChangYu.glb",name:'dachangyu'},
                          {cfg:"zhen_SanYinJiao.glb",name:"sanyinjiao"},
                          {cfg:"zhen_TianShu.glb",name:"tianshu"},
                          {cfg:"zhen_ShangJuXu.glb", name:"shangjuxu"},
                          {cfg:"zhen_taichong.glb",name:"taichong"},
                          {cfg:"aijiu.glb",name:"shenque"},
                          {cfg:"zhen_qimen.glb",name:"qimen"}];

        let n = modelNames.length;
        while(n--) {
            let item = modelNames[n];
            let model =  this.app.loader.models[ item.cfg ];       
            model.visible = true;
            
            model.traverse(node=>{
                if( node.isMesh ) {
                    if( !this.zhens[item.name] ) {
                        this.zhens[item.name] = node;
                        node.geometry.computeBoundingBox();
                        let size = new THREE.Vector3();
                        node.geometry.boundingBox.getSize( size );
                        this.zhensArr.push( node );
                        node.zhenname = item.name;
                        node.boxsize = size;
                        
                    }
                }
            });
        }

        console.log( this.zhens );

        this.INTERSECTED = null;
        this.raycaster = new THREE.Raycaster();

        //ui 状态调整
        modelNames.forEach(item=>{
            this.options[item.name].refs.root.style.opacity = 0;
            
            setTimeout(() => {
                this.options[item.name].init();
            }, 100);
        })

        this.app.setRentiRotate('up');

        //放上所有学生的针
        if( this.app.placedYinzhen )
        {
            this.app.placedYinzhen.forEach(item=>{
                this.app.scene.add( item );
            })
        }
    }

    exit(){

        if( this.app.placedYinzhen )
        {
            this.app.placedYinzhen.forEach(item=>{
                this.app.scene.remove( item );
            })
            this.app.placedYinzhen = [];
        }

        let modelNames = [{cfg:"zhen_DaChangYu.glb",name:'dachangyu'},
        {cfg:"zhen_SanYinJiao.glb",name:"sanyinjiao"},
        {cfg:"zhen_TianShu.glb",name:"tianshu"},
        {cfg:"zhen_ShangJuXu.glb", name:"shangjuxu"},
        {cfg:"zhen_taichong.glb",name:"taichong"},
        {cfg:"aijiu.glb",name:"shenque"},
        {cfg:"zhen_qimen.glb",name:"qimen"}];

        let n = modelNames.length;
        while(n--) {
            let item = modelNames[n];
            let model =  this.app.loader.models[ item.cfg ];       
            model.visible = false;
        }
    }

    onClick(event)
    {
        let name = this.hoverCheck();
        console.log(name);
        if( this.currShowAnchor )
        {
            let dom = this.options[this.currShowAnchor].refs.root;
            dom.style.opacity = 0;
        }

        this.currShowAnchor = name;

        if( name ) {
            let comp = this.options[this.currShowAnchor];
            let dom = comp.refs.root;
            dom.style.opacity = 1;
            comp.play();
        }
    }

    hoverCheck( )
    {
        let raycaster = this.raycaster;

        raycaster.setFromCamera( this.app.mouse, this.app.activeCamera);

        this.boxArr.forEach(item=>item.visible = true);
        let intersections = raycaster.intersectObjects( this.boxArr , true);
        this.boxArr.forEach(item=>item.visible = false);

        let INTERSECTED = this.INTERSECTED;

        if( intersections && intersections.length > 0 )
        {
            let box = intersections[0].object;
            let intersectionObj = this.zhens[box.name];
            box.visible = true;
            if ( INTERSECTED != intersectionObj ) {

                if ( INTERSECTED ) INTERSECTED.material.emissive.setHex( INTERSECTED.currentHex );

                INTERSECTED = intersectionObj;
                this.INTERSECTED = intersectionObj;

                INTERSECTED.currentHex = INTERSECTED.material.emissive.getHex();
                INTERSECTED.material.emissive.setHex( 0xff0000 );
                box.visible = true;
            }
            return box.name;

        } 
        if ( INTERSECTED ) {
            INTERSECTED.material.emissive.setHex( INTERSECTED.currentHex );
            this.box[INTERSECTED.zhenname].visible = false;
        }

        this.INTERSECTED = null;
    }

    update(){
        if( this.currShowAnchor ) {
            
            let xuewei = ["qimen", "dachangyu","sanyinjiao","taichong","tianshu","shenque","shangjuxu"];

                let node = this.anchors[this.currShowAnchor];
                node.getWorldPosition( this.tempVec3 );
                // console.log( this.tempVec3.x, this.tempVec3.y);

                this.tempVec3.project( this.app.activeCamera );
                let x =  ( 1 + this.tempVec3.x ) * 0.5 * this.app.el.clientWidth;
                let y =  ( 1 - this.tempVec3.y ) * 0.5 * this.app.el.clientHeight;
                // console.log(x, y);

                let qimen = this.options[this.currShowAnchor].refs.root;
                if( qimen ) {
                    qimen.style.left = x + 'px';
                    qimen.style.top = y + 'px';
                }
            // console.log( x, y);
        }
        this.hoverCheck();
    }
}

export default ResultState;